import { makeStyles } from 'tss-react/mui';
import { themeColors, themeLayout } from 'app/shared/theme';

export const useStyles = makeStyles()(theme => ({
  modal: {
    backgroundColor: themeColors.accentDark60,
    overflowY: 'scroll',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  infoIcon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:hover svg': {
      stroke: themeColors.mbsBlue,
    },
  },
  wrapper: {
    width: 561,
    height: 636,
    boxSizing: 'border-box',
    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: 500,
    },
    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
    },
    margin: 'auto',
    outline: 'none !important',
  },
  sectionItem: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: 4,
  },
  valueContainer: {
    wordWrap: 'break-word',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ageContainerLight: {
    padding: '4px 8px',
    borderRadius: 2,
    backgroundColor: themeColors.greyscale4_50,
    boxSizing: 'border-box',
    width: 'fit-content',
    marginLeft: 5,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    backgroundColor: themeColors.white,
    padding: 16,

    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: 500,
    },
    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
    },
  },
  subheader: {
    paddingBottom: 8,
    paddingTop: 16,
    borderBottom: `2px solid ${themeColors.greyscale4}`,
    marginBottom: 8,
  },
  dosageModalWrapper: {
    width: 960,
    maxWidth: '95vw',
    maxHeight: '90vh',
    margin: 'auto',
    outline: 'none !important',
    backgroundColor: themeColors.white,
    [theme.breakpoints.down(themeLayout.breakpointBig)]: {
      width: '90vw',
    },
    [theme.breakpoints.down(themeLayout.breakpointSmall)]: {
      width: '100%',
      maxWidth: '100vw',
    },
  },
  dosageModalHeader: {
    width: '100%',
    position: 'relative',
    padding: '18px 20px',
    borderBottom: `1px solid ${themeColors.greyscale4}`,
    '& > div:first-child': {
      minWidth: 0,
      flex: 1,
    },
    '& img': {
      flexShrink: 0,
      width: 24,
      height: 24,
      marginLeft: 16,
    },
    '& h2': {
      fontSize: 18,
      lineHeight: 1.25,
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
  },
  dosageTableContainer: {
    padding: 16,
    overflow: 'auto',
  },
  dosageInformation: {
    padding: '12px 12px 0',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  dosageTable: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th, & td': {
      padding: 5,
      textAlign: 'left',
      border: `2px solid ${themeColors.greyscale4}`,
      fontSize: 13,
      lineHeight: 1.4,
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      verticalAlign: 'middle',
    },
    '& th:first-child, & td:first-child': {
      width: 70,
      minWidth: 70,
      maxWidth: 70,
    },
    '& th:first-child': {
      padding: 0,
      height: 38,
      lineHeight: 1,
    },
    '& th:not(:first-child), & td:not(:first-child)': {
      width: 70,
      minWidth: 70,
      padding: 0,
      textAlign: 'center',
    },
    '& th': {
      color: themeColors.greyscale2,
    },
  },
  dosageMatchSquare: {
    width: '100%',
    minWidth: 0,
    height: 38,
    boxSizing: 'border-box',
    border: `2px solid ${themeColors.greyscale4}`,
    borderRadius: 2,
    backgroundColor: themeColors.greyscale5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
  },
  dosageSelectedCell: {
    backgroundColor: themeColors.highlightBlue,
    borderColor: themeColors.mbsBlue,
    fontWeight: 700,
  },
  dosageCornerHeader: {
    position: 'relative',
    display: 'table-cell',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    height: 38,
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    overflow: 'hidden',
    background: `linear-gradient(to top right, transparent 49%, ${themeColors.greyscale4} 50%, transparent 51%)`,
  },
  dosageCornerTemperature: {
    position: 'absolute',
    left: 4,
    bottom: 3,
    width: 60,
    maxWidth: 60,
    textAlign: 'left',
    fontSize: 10,
    lineHeight: 1.05,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    zIndex: 1,
  },
  dosageCornerBatchAge: {
    position: 'absolute',
    top: 3,
    right: 4,
    width: 60,
    maxWidth: 60,
    textAlign: 'right',
    fontSize: 10,
    lineHeight: 1.05,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    zIndex: 1,
  },
  dosageSelectedRow: {
    backgroundColor: themeColors.highlightBlue,
    fontWeight: 700,
  },
}));
